import React, { useState, useEffect, useRef ,Suspense} from "react";
import Slider from "react-slick";
import parse from 'html-react-parser';
import { useOutletContext, useParams } from "react-router-dom"
import { useAppContext } from "../Context/Store";
//import Breadcrumb from "../components/Layout/BreadCrumb";
const Breadcrumb = React.lazy(() => import('../components/Layout/BreadCrumb'));

// const settings = {
//   slidesToShow: 1,
//   slidesToScroll: 1, 
//   fade: true,
//   dots: false,
//   arrows: false,
//   //asNavFor: '.slider-nav'
// };
// const settings1 = {
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   vertical:true,  
//   dots: false,
//   arrows: false,
//   focusOnSelect: true,
//   verticalSwiping:true,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         vertical: true,
//       }
//     }
//   ]
// };
export default function CustomizedDetails({ sendBodyClass }) {

    const { isError, isLoading, CustomizedData, ContactData, domainURL, domainURLCMS } = useAppContext();
    const contextData = useOutletContext();
 
    // Function to handle input change
    const handleChange = () => { 
      //setInputValue(true);
      contextData(true);
      //console.log("Click Value", inputValue);
  };

  const [nav1, setNav1] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slider1, setSlider1] = useState(null);

  const settings = {
    onReInit: () => setCurrentSlide(slider1?.innerSlider.state.currentSlide),
    lazyLoad: true,
    fade: true,
    asNavFor: ".slider-nav",
    focusOnSelect: true,
  };
  
  //const [nav1, setNav1] = useState(null);
  //const [nav2, setNav2] = useState(null);

  //let sliderRef1 = useRef(null);
  //let sliderRef2 = useRef(null);

    let params = useParams();
    //console.log(params);

    const CustomizedcategoryItem = Array.isArray(CustomizedData?.items) ? CustomizedData?.items.find((Item, index) => {
        return Item.id === params.id;
    }) : [];

    //console.log(CustomizedcategoryItem);
    // const CustomizedcategoryItem = CustomizedData?.items.find((Item, index) => {
    //     return Item.id === params.id;
    // });
  
    const { properties } = CustomizedcategoryItem;
  useEffect(() => {
    sendBodyClass(false);
    //setNav1(sliderRef1);
    //setNav2(sliderRef2);
    setNav1(slider1);
  }, []);
  
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
      <Breadcrumb 
        mainitemNameVal={`Customized`} 
        mainitemNameValLink={`customized`} 
        itemNameVal={`${CustomizedcategoryItem?.name || ""}`} 
        itemNameValId={``} 
        subitemNameVal={``} 
      />
      <section className="product-detail-slider">
          <div className="inner">
             <article className="slider-inner">
                  <aside className="slider-nav"> 
                  
        <div className="thumb-wrapper">
          {Array.isArray(properties?.sliderItems?.items) && properties?.sliderItems?.items.map((item, idx) => (
            <div
              key={item.id}
              className={`thumbImg ${currentSlide === idx ? "active": null}`}
              onClick={() => {
                slider1?.slickGoTo(idx)
              }}>
              {
                Array.isArray(item?.content?.properties?.image) && item?.content?.properties?.image.map((itemChild, index) => {
                  return <img key={itemChild?.id || `${idValue}-${itemChild.id}`} src={`${domainURLCMS}/${itemChild?.url}`} alt="" />
                  })
              } 
              {/* {currentSlide} */}
            </div>
          ))}
        </div>
                    {/* <Slider {...settings1} 
        asNavFor={nav1}
        ref={slider => (sliderRef2 = slider)}
        slidesToShow={4}
        swipeToSlide={true}
        focusOnSelect={true}>
                                        {
Array.isArray(properties?.sliderItems?.items) && properties?.sliderItems?.items.map((item, index) => {
  const idValue = index;
    return (
      <div className="thumbImg" key={item?.id || idValue}>
        {
           Array.isArray(item?.content?.properties?.image) && item?.content?.properties?.image.map((itemChild, index) => {
            return <img key={itemChild?.id || `${idValue}-${itemChild.id}`} src={`${domainURLCMS}/${itemChild?.url}`} alt="" />
            })
        }
    
      </div>
    ) 
})

}
                    </Slider>   */}
                  </aside>
                  <article className="slider-for">
                  <Slider {...settings} asNavFor={nav1} ref={(slider) => setSlider1(slider)}>
                    {
                      Array.isArray(properties?.sliderItems?.items) && properties?.sliderItems?.items.map((item, index) => {
                        const idValue = index;
                          return (<figure key={item?.id || idValue}>
                              {Array.isArray(item?.content?.properties?.image) && item?.content?.properties?.image.map((itemChild, index) => {
                                  return <img key={itemChild?.id || `${idValue}-${itemChild.id}`} src={`${domainURLCMS}/${itemChild?.url}`} alt="" />
                              })
                          }
                          </figure>
                        )
                      })
                    } 
                  </Slider>
                  {/* <Slider {...settings} asNavFor={nav2} ref={slider => (sliderRef1 = slider)}>
                      {

                          Array.isArray(properties?.sliderItems?.items) && properties?.sliderItems?.items.map((item, index) => {
                            const idValue = index;
                              return (<figure key={item?.id || idValue}>
                                  {Array.isArray(item?.content?.properties?.image) && item?.content?.properties?.image.map((itemChild, index) => {
                                      return <img key={itemChild?.id || `${idValue}-${itemChild.id}`} src={`${domainURLCMS}/${itemChild?.url}`} alt="" />
                                  })
                              }
                              
                              </figure>
                            )
                          })
                                            
                      } 
                  </Slider>  */}
                  </article>
              </article> 
              <article className="slider-info">
                  <div className="info">
                    {parse(`${properties?.detailDescription?.markup}`)}
                  </div>
                  <div className="btn-c whatsapp">
                      <a href={`https://wa.me/+${ContactData?.properties?.phone.replace(/ /g, '')}`} target="_blank">
                          <b>{ContactData?.properties?.customerSupportLabelText}</b>
                          <span>Customer Supports </span>
                          <span>Chat with us!</span>
                      </a>
                  </div>
                  <div className="btn-c phone">
                      <a href={`tel:+${ContactData?.properties?.phone.replace(/ /g, '')}`} target="_blank">
                          <b>{ContactData?.properties?.callUsLabelText}</b>
                          <span>Order/Mockup</span>
                          <span>+{ContactData?.properties?.phone}</span>
                      </a>
                  </div>
                  <a className="btn quote" onClick={handleChange}>Request a quote</a>
              </article>
          </div>
      </section>
      {/* <h1>Categorie Details Page {categoryItem.name}</h1>
      <p>This is the categorie details page.</p>
      <button>Back to Home</button> */}

</Suspense>
    </>
  )
}
